

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';

@Component
export default class AddAdminModal extends Vue {
    @Prop({ default: false })
    visible: boolean;
    @Prop({ default: 0 })
    id: number;
    @Prop({ default: 'admin' })
    type: 'admin' | 'inspector';

    show: boolean = false;
    userList: CommonTypes.UserInfoItem[] = [];
    orinigalUser: CommonTypes.UserInfoItem[] = [];
    formCustom: CommonTypes.mapObject = {
        inspector: []
    };

    btnLoading: Boolean = false;
    searchLoading: Boolean = false;
    $refs: any;

    @Watch('visible', { immediate: true })
    onShowChanged(val) {
        this.show = val;
        if (val) {
            this.formCustom.inspector = [];
        }
    }
    close() {
        this.$emit('update:visible', false);
    }
    mounted() {
        this.getSpaceAdmin();
    }
    handleMemberChanged(val) {
        this.formCustom.inspector = val.map(item => item.username);
    }
    async getSpaceAdmin() {
        const res = await api.spaceApi.getSpaceAdmin(this.spaceId);
        const { code, data } = res;
        if (code === 200) {
            this.userList = Object.assign([], data.items);
            this.orinigalUser = Object.assign([], data.items);
        }
    }
    async remoteMethod(query) {
        if (!query) {
            this.userList = this.orinigalUser;
            return;
        }
        this.searchLoading = true;
        this.userList = this.userList.filter(item => {
            return item.displayName.includes(query) || item.username.includes(query);
        });
        this.searchLoading = false;
    }
    async submit() {
        if (this.btnLoading) {
            return;
        }
        this.btnLoading = true;
        try {
            await api.inspectApi.addInspector({
                nameList: this.formCustom.inspector,
                objectId: this.spaceId,
                role: this.type.toUpperCase()
            });
            this.$mtd.message({
                message: `添加${this.name}成功`,
                type: 'success'
            });
            this.$emit('success');
            this.close();
        } catch (e) {
            console.log(e);
        }
        this.btnLoading = false;
    }
    get spaceId() {
        return parseInt(this.$route.params.id, 10);
    }
    get name() {
        return this.type === 'admin' ? '质检管理员' : '质检员';
    }
}
